export const ratingBoardStyle = {
  pointerEvents: 'auto',
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: { xs: 34, lg: 'unset' },
  mx: 'auto',
  maxWidth: '750px',
  borderRadius: { xs: '20px 20px 0 0', lg: '0px 0px 8px 8px' },
  background: '#FFF',
  backdropFilter: 'blur(20px)',
  padding: '0px 0px 30px 0px',
  overflow: 'hidden', // Ensure content doesn't show outside during animation

  '@keyframes slide-down-fade-in': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-20px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  '@keyframes mobile-slide-up': {
    '0%': {
      bottom: '-100%',
    },
    '100%': {
      bottom: 34,
    },
  },

  '@keyframes fade-out': {
    '0%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
    '100%': {
      opacity: 0,
      transform: 'translateY(20px)',
    },
  },

  '@keyframes fade-out-mobile': {
    '0%': {
      bottom: 34,
    },
    '100%': {
      bottom: '-100%',
    },
  },
};

export const menuButtonStyle = {
  background: 'transparent',
  width: '47px',
  height: '20px',
  position: 'absolute',
  left: 0,
  right: 0,
  mx: 'auto',
  pointerEvents: 'all',
};
